import type { UpdateCommunityProfilePayload, UserCommunityProfile } from '~/api/community/types';

import type { EditUserCommunityProfileFormType } from './types';

export const mapUserCommunityProfileFormDataToPayload = (
  data: EditUserCommunityProfileFormType,
  enabled: boolean,
): UpdateCommunityProfilePayload => ({
  enabled,
  email: data.email,
  description: data.description,
  regions: data.regions,
  brandId: data.brandId,
  openToWork: data.openToWork,
  links: data.links,
});

export const mapUserCommunityProfileResponseToFormData = (communityProfile: UserCommunityProfile): EditUserCommunityProfileFormType => ({
  email: communityProfile.email,
  description: communityProfile.description ?? '',
  regions: communityProfile.regions,
  brandId: communityProfile.brandId,
  openToWork: communityProfile.openToWork,
  links: {
    website: communityProfile.links.website ?? '',
    linkedIn: communityProfile.links.linkedIn ?? '',
    instagram: communityProfile.links.instagram ?? '',
    facebook: communityProfile.links.facebook ?? '',
    behance: communityProfile.links.behance ?? '',
  },
});
